<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="assistant-page">
    <div class="grid">
        <!-- Prompt -->
        <div class="card">
            <h2><i class="fa-solid fa-robot"></i> Claude AI Research</h2>
            <p class="hint">Describe what you're looking for and Claude will research companies matching your query.</p>

            <label class="field-label">Research prompt</label>
            <textarea
                class="prompt-input"
                [(ngModel)]="prompt"
                placeholder="e.g. Find office parks near Sandton with parking facilities"
                rows="4"
                (keydown.meta.enter)="research()"
                (keydown.control.enter)="research()"
            ></textarea>

            <button class="research-btn" [disabled]="researching || !prompt.trim()" (click)="research()">
                <i class="fa-solid" [class.fa-spinner]="researching" [class.fa-spin]="researching" [class.fa-wand-magic-sparkles]="!researching"></i>
                {{ researching ? 'Researching...' : 'Research' }}
            </button>

            <div class="alert alert--ok" *ngIf="message">{{ message }}</div>
            <div class="alert alert--err" *ngIf="error">{{ error }}</div>
        </div>

        <!-- Map -->
        <div class="card map-card">
            <h2><i class="fa-solid fa-map-location-dot"></i> Map preview</h2>
            <agm-map [latitude]="mapCenter.lat" [longitude]="mapCenter.lng" [zoom]="mapZoom" [styles]="[]">
                <ng-container *ngFor="let r of results">
                    <agm-marker
                        *ngIf="r.latitude && r.longitude"
                        [latitude]="r.latitude"
                        [longitude]="r.longitude"
                        [iconUrl]="'https://maps.google.com/mapfiles/ms/icons/purple-dot.png'"
                        [title]="r.name"
                    ></agm-marker>
                </ng-container>
            </agm-map>
        </div>
    </div>

    <!-- Results -->
    <div class="card" *ngIf="results.length">
        <div class="results-header">
            <h2><i class="fa-solid fa-building"></i> Results ({{ results.length }})</h2>
            <button class="import-btn" [disabled]="importing || !selectedCount" (click)="importSelected()">
                <i class="fa-solid" [class.fa-spinner]="importing" [class.fa-spin]="importing" [class.fa-file-import]="!importing"></i>
                {{ importing ? 'Importing...' : 'Import Selected (' + selectedCount + ')' }}
            </button>
        </div>

        <div class="results-list">
            <label class="result-item" *ngFor="let r of results" [class.result-item--selected]="r.selected">
                <input type="checkbox" [(ngModel)]="r.selected" />
                <div class="result-body">
                    <div class="result-name">{{ r.name }}</div>
                    <div class="result-detail" *ngIf="r.address"><i class="fa-solid fa-location-dot"></i> {{ r.address }}</div>
                    <div class="result-detail" *ngIf="r.website"><i class="fa-solid fa-globe"></i> <a [href]="r.website" target="_blank">{{ r.website }}</a></div>
                    <div class="result-detail" *ngIf="r.phone"><i class="fa-solid fa-phone"></i> {{ r.phone }}</div>
                    <div class="result-detail" *ngIf="r.notes"><i class="fa-solid fa-note-sticky"></i> {{ r.notes }}</div>
                    <div class="result-coords" *ngIf="r.latitude && r.longitude">
                        <i class="fa-solid fa-map-pin"></i> {{ r.latitude | number: '1.4-4' }}, {{ r.longitude | number: '1.4-4' }}
                    </div>
                </div>
            </label>
        </div>
    </div>
</div>
